var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "#3B82F6",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99992 15.1663C4.31792 15.1663 1.33325 12.1817 1.33325 8.49967C1.33325 4.81767 4.31792 1.83301 7.99992 1.83301C11.6819 1.83301 14.6666 4.81767 14.6666 8.49967C14.6666 12.1817 11.6819 15.1663 7.99992 15.1663ZM7.99992 13.833C9.41441 13.833 10.771 13.2711 11.7712 12.2709C12.7713 11.2707 13.3333 9.91416 13.3333 8.49967C13.3333 7.08519 12.7713 5.72863 11.7712 4.72844C10.771 3.72824 9.41441 3.16634 7.99992 3.16634C6.58543 3.16634 5.22888 3.72824 4.22868 4.72844C3.22849 5.72863 2.66659 7.08519 2.66659 8.49967C2.66659 9.91416 3.22849 11.2707 4.22868 12.2709C5.22888 13.2711 6.58543 13.833 7.99992 13.833ZM7.33325 5.16634H8.66659V6.49967H7.33325V5.16634ZM7.33325 7.83301H8.66659V11.833H7.33325V7.83301Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info_icon.66160364f431eb1261673ce29b46fce9.svg";
export { ForwardRef as ReactComponent };